<div class="m-portlet--tab">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="">
                <div class="m-portlet__head-text title-style">
                    Search Results
                </div>
            </div>
        </div>
    </div>
</div>
<div class="">
    <label>
        <!-- Searched Job Roles: <span class="color-info"></span> -->
    </label>
    <table class="table table-striped m-table">
        <thead class="m-datatable__head">
            <tr class="m-datatable__row">
                <th>
                    <b>Batch ID</b>
                </th>
                <th>
                    <b>Batch Type</b>
                </th>
                <th>
                    <b>Batch Mode</b>
                </th>
                <th>
                    <b>Job Role Name (QP Code)</b>
                </th>
                <th>
                    <b>ToT/ToA Centre Name (ID)</b>
                </th>
                <th>
                    <b>State</b>
                </th>
                <th>
                    <b>District</b>
                </th>
                <th>
                    <b>Start Date - End Date</b>
                </th>
                <th>
                    <b>Action</b>
                </th>
            </tr>
        </thead>
        <tbody class="notranslate" *ngIf="searchedData && searchedData.length > 0; else showError">
            <tr *ngFor="let data of searchedData; let i = index;">
                <td>{{data.batchId}}</td>
                <td>{{data.type}}</td>
                <td>{{data?.totMode || 'N/A'}}</td>
                <td>
                    <span *ngFor="let jobs of data.jobRoles; let isLast=last">{{jobs?.jobName}}
                        ({{jobs?.qpCode}}){{isLast ? '' :
							', '}}</span>
                </td>
                <td>{{data.tcName?data.tcName:'N/A'}} ({{data.tcId ? data.tcId : "NA"}}) </td>
                <td>{{data?.address?.state?.name || 'N/A'}}</td>
                <td>{{data?.address?.district?.name || 'N/A'}}</td>
                <td>{{data.batchStartDate | date:'dd/MM/yyyy'}}
                    <span class="color-info">
                        <b>to</b>
                    </span> {{data.batchEndDate | date:'dd/MM/yyyy'}}</td>
                <td>
                    <span style="overflow: visible; width: 100px;">
                        <div class="dropdown">
                            <a href="javascript:;"
                                class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
                                data-toggle="dropdown">
                                <i class="la la-ellipsis-h"></i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                                <a class="dropdown-item"
                                    routerLink="../view-batch-details/{{data.status}}/{{data.batchId}}">
                                    View Batch Details
                                </a>
                                <a class="dropdown-item" (click)="applyToBatch(data)">
                                    Apply to the Batch
                                </a>
                            </div>
                        </div>
                    </span>
                </td>
            </tr>
        </tbody>
        <ng-template #showError>
            <p class="no-content"> No Data Found...</p>
        </ng-template>
    </table>
</div>